import React, { useState } from 'react'
import { IconButton, ThemeProvider, Toolbar, createTheme, Button, Drawer, ListItemButton, ListItemText, List, Box} from '@mui/material'
import AppBar from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu'
import './Navbar.css'
import logo from '../../Assets/proantraLogo.png'

const theme = createTheme({
    palette: {
        mode: 'dark',

    }
})



const Navbar = () => {
    const [isDrawerOpen, setIsDrawerOpen ] = useState(false)
    
    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen)
    }

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId)
        if (section) {
            section.scrollIntoView({behavior: 'smooth'})
        }
    }

  return (
    <ThemeProvider theme={theme}>
        <AppBar sx={{background: '#064760'}} position = 'fixed'>
            <Toolbar>
                <IconButton color='inherit' onClick={toggleDrawer}>
                    <MenuIcon/>
                </IconButton>
                <Box sx={{textAlign: 'center'}}>
                 <img src={logo} alt='Logo' style = {{maxWidth: '100%', height: 'auto', marginTop: '1.5rem', marginBottom: '1rem', marginLeft: '1rem',
                     marginRight: '5rem'}}/>
                </Box>
                <div className='nav-buttons'>
                    <Button sx={{marginLeft: '1rem', padding: '2rem',  borderRadius: '1rem', border: 0, color: 'white', 
                                 fontWeight: 'bold', boxShadow: 'none',transition: 'transform 0.3s', 
                                 }} onClick={()=> scrollToSection('home')}>
                        Home 
                    </Button>
                    <Button sx={{marginLeft: '1rem', padding: '2rem',  borderRadius: '1rem', border: 0, color: 'white', 
                                 fontWeight: 'bold', boxShadow: 'none',transition: 'transform 0.3s', 
                                 }} onClick={()=> scrollToSection('valueProposition')}>
                        Value Proposition
                    </Button>
                    <Button sx={{marginLeft: '1rem', padding: '2rem',  borderRadius: '1rem', border: 0, color: 'white', 
                                 fontWeight: 'bold', boxShadow: 'none',transition: 'transform 0.3s', 
                                 }} onClick={()=> scrollToSection('products')}>
                        Featured Products
                    </Button>
                    <Button sx={{marginLeft: '1rem', padding: '2rem',  borderRadius: '1rem', border: 0, color: 'white', 
                                 fontWeight: 'bold', boxShadow: 'none',transition: 'transform 0.3s', 
                                 }} onClick={()=> scrollToSection('aboutUs')}> 
                        About
                    </Button>
                    <Button sx={{marginLeft: '1rem', padding: '2rem',  borderRadius: '1rem', border: 0, color: 'white', 
                                 fontWeight: 'bold', boxShadow: 'none',transition: 'transform 0.3s', 
                                 }} onClick={()=> scrollToSection('contact')}>
                        Contact
                    </Button>
                    
                </div>
            </Toolbar>
        </AppBar>

        <Drawer anchor='left' open= {isDrawerOpen} onClose = {toggleDrawer}>
            <List>
                <ListItemButton onClick={()=> scrollToSection('home')}>
                    <ListItemText primary = 'Home'/>
                </ListItemButton>
                <ListItemButton onClick={()=> scrollToSection('valueProposition')}>
                    <ListItemText primary = 'Value Preporition'/>
                </ListItemButton>
                <ListItemButton onClick={()=> scrollToSection('products')}>
                    <ListItemText primary = 'Featured Products'/>
                </ListItemButton>
                <ListItemButton onClick={()=> scrollToSection('aboutUs')}>
                    <ListItemText primary = 'About'/>
                </ListItemButton>
                <ListItemButton onClick={()=> scrollToSection('contact')}>
                    <ListItemText primary = 'Contact'/>
                </ListItemButton>
            </List>
            
        </Drawer>


    </ThemeProvider>
  )
}

export default Navbar

